import {
  AdminPanelSettings as AdminIcon,
  Person as UserIcon,
} from "@mui/icons-material";
import { Avatar, Box, Chip, Typography } from "@mui/material";

const AdminInfoDisplay = ({
  admin,
  label = "Admin",
  showRole = true,
  size = "medium",
}) => {
  if (!admin) return null;

  const avatarSize = size === "small" ? 20 : size === "large" ? 32 : 24;
  const chipHeight = size === "small" ? 16 : size === "large" ? 24 : 20;
  const fontSize =
    size === "small" ? "0.6rem" : size === "large" ? "0.8rem" : "0.7rem";

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}
    >
      {label && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontSize, textTransform: "capitalize" }}
        >
          {label}:
        </Typography>
      )}
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Avatar
          sx={{
            width: avatarSize,
            height: avatarSize,
            bgcolor: admin.role === "admin" ? "primary.main" : "secondary.main",
          }}
        >
          {admin.role === "admin" ? (
            <AdminIcon fontSize="small" />
          ) : (
            <UserIcon fontSize="small" />
          )}
        </Avatar>
        <Typography variant="caption" sx={{ fontSize }}>
          {admin.email}
        </Typography>
        {showRole && (
          <Chip
            label={admin.role.toUpperCase()}
            color={admin.role === "admin" ? "primary" : "secondary"}
            size="small"
            sx={{ height: chipHeight, fontSize }}
          />
        )}
      </Box>
    </Box>
  );
};

export default AdminInfoDisplay;
